import { TableConfig } from '../../../../components/table/Table';

export const initBerechnteileTableConfig = (): TableConfig => {
  return [
    {
      id: 1,
      columnName: 'Bereich',
      attributName: 'bereich',
      valueType: 'string',
    },
    {
      id: 2,
      columnName: 'Leistungsdatum',
      attributName: 'leistungsDatum',
      valueType: 'string',
    },
    {
      id: 3,
      columnName: 'Status',
      attributName: 'status',
      valueType: 'string',
    },
    {
      id: 4,
      columnName: 'Rg.-Empf..',
      attributName: 'rechnungsEmpfaenger',
      valueType: 'string',
    },
    {
      id: 5,
      columnName: 'Währung',
      attributName: 'waehrung',
      valueType: 'string',
    },
    {
      id: 6,
      columnName: 'Schema',
      attributName: 'schema',
      valueType: 'string',
    },
    {
      id: 7,
      columnName: 'fpfl. Gewicht',
      attributName: 'frachtpflichtigesGewicht',
      valueType: 'string',
    },
    {
      id: 8,
      columnName: 'km',
      attributName: 'km',
      valueType: 'float',
      fixedDecimalScale: true,
    },
    {
      id: 9,
      columnName: 'von Ort',
      attributName: 'vonOrt',
      valueType: 'string',
    },
    {
      id: 10,
      columnName: 'bis Ort',
      attributName: 'bisOrt',
      valueType: 'string',
    },
    {
      id: 11,
      columnName: 'Betrag',
      attributName: 'betrag',
      valueType: 'float',
      fixedDecimalScale: true,
    },
    {
      id: 12,
      columnName: 'Ertrag',
      attributName: 'ertrag',
      valueType: 'float',
      fixedDecimalScale: true,
    },
  ];
};
